import React, { useState } from "react";
import { Form, Input, Row, Col, message, Modal, Button } from "antd";
import { Auth } from "aws-amplify";
import AppConfig from "../../config/AppConfig";
import { getUser, verifyName } from "../../../Api/Apis";
import NumberFormat from "react-number-format";
import { industries } from "../masterLists";
import { Link } from "react-router-dom";

const Section1 = ({ formValues, setFormValues }) => {
  const [visible, setVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
 const signedIn = !!formValues.signedInExisting;
  // Auto-fill state as Connecticut when street is entered (but still editable)
  const handleStreetChange = (e) => {
    const newStreet = e.target.value;
    setFormValues({
      ...formValues,
      street: newStreet,
      state: newStreet && !formValues.state ? "Connecticut" : formValues.state,
    });
  };

  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);

  const handleSignin = async (e) => {
    e?.preventDefault();
    if (!username || !password) {
      message.warning("Please enter username and password.");
      return;
    }
    await handleLogin(username, password);
  };

  const handleLogin = async (Username, Password) => {
    try {
      setLoggingIn(true);
      const user = await Auth.signIn(Username, Password);
      localStorage.setItem("user", JSON.stringify(user.username));

      const res = await getUser(
        AppConfig["entityNames"]["questionnaires"],
        user.username
      );
      if (res?.success && res.data) {
        const u = res.data;
        console.log("buisinessU", u);
        const mapQuestionnaireToForm = (u) => ({
          // Section1
          businessName: u.businessName ?? "",
          contactName: u.contactName ?? u.contactPerson ?? "",
          contactTitle: u.contactTitle ?? "",
          email: u.email ?? "",
          phone: u.phone ?? "",
          street: u.street ?? "",
          city: u.city ?? "",
          state: u.state ?? "",
          zip: u.zip ?? "",
          // ids & flags
          signedInExisting: true,
          questionnaireId: u.id,
          id: u.id,
          // Section 2
          industries: Array.isArray(u.industries)
            ? u.industries
            : u.industries
            ? [u.industries]
            : Array.isArray(u.industry)
            ? u.industry
            : u.industry
            ? [u.industry]
            : [],
          entityType: u.entityType ?? u.businessEntityType ?? "",
          counties: Array.isArray(u.service)
            ? u.service
            : u.service
            ? [u.service]
            : Array.isArray(u.area)
            ? u.area
            : u.area
            ? [u.area]
            : [],
          // Section 3
          objectivesAwareness: Array.isArray(u.objectivesAwareness)
            ? u.objectivesAwareness
            : u.objectivesAwareness
            ? [u.objectivesAwareness]
            : [],

          objectivesEngagement: Array.isArray(u.objectivesEngagement)
            ? u.objectivesEngagement
            : u.objectivesEngagement
            ? [u.objectivesEngagement]
            : [],
          objectivesAction: Array.isArray(u.objectivesAction)
            ? u.objectivesAction
            : u.objectivesAction
            ? [u.objectivesAction]
            : [],
          successMetrics: Array.isArray(u.successMetrics)
            ? u.successMetrics.map((s) => String(s).trim())
            : u.successMetrics
            ? [String(u.successMetrics).trim()]
            : [],
          startTime: u.startTime ?? u.adStartTime ?? "",
          // Section 4
          hasSpent: u.hasSpent ?? "",
          adTypes: Array.isArray(u.adTypes)
            ? u.adTypes
            : u.adTypes
            ? [u.adTypes]
            : [],
          adTypesOther: u.adTypesOther ?? "",
          adReasons: Array.isArray(u.adReasons)
            ? u.adReasons
            : u.adReasons
            ? [u.adReasons]
            : [],
          adReasonsOther: u.adReasonsOther ?? "",
          adEffectiveness: u.adEffectiveness ?? "",
          adResults: Array.isArray(u.adResults)
            ? u.adResults
            : u.adResults
            ? [u.adResults]
            : [],
          adResultsOther: u.adResultsOther ?? "",
          adFailures: Array.isArray(u.adFailures)
            ? u.adFailures
            : u.adFailures
            ? [u.adFailures]
            : [],
          adFailuresOther: u.adFailuresOther ?? "",
          adWorth: u.adWorth ?? "",
          adFrequency: u.adFrequency ?? "",
          // Section 5
          gender: Array.isArray(u.gender)
            ? u.gender
            : u.gender
            ? [u.gender]
            : [],
          household: Array.isArray(u.household)
            ? u.household
            : u.household
            ? [u.household]
            : [],
          lifeStage: Array.isArray(u.lifeStage)
            ? u.lifeStage
            : u.lifeStage
            ? [u.lifeStage]
            : [],
          ageGroups: Array.isArray(u.ageGroups ?? u.agegroup)
            ? (u.ageGroups ?? u.agegroup).map((s) =>
                String(s).replace(/-/g, "-").trim()
              )
            : u.ageGroups ?? u.agegroup
            ? [
                String(u.ageGroups ?? u.agegroup)
                  .replace(/-/g, "-")
                  .trim(),
              ]
            : [],
          ethnicGroups: Array.isArray(u.ethnicGroups)
            ? u.ethnicGroups
            : u.ethnicGroups
            ? [u.ethnicGroups]
            : [],
          ethnicGroupsOther: u.ethnicGroupsOther ?? "",
          // Section 6
          marketingAssets: Array.isArray(u.marketingAssets)
            ? u.marketingAssets
            : u.marketingAssets
            ? [u.marketingAssets]
            : [],
          marketingAssetsOther: u.marketingAssetsOther ?? "",
          assetsStatus: u.assetsStatus ?? "",
          lastUpdatedAssets: u.lastUpdatedAssets ?? "",
          businessHighlights: Array.isArray(u.businessHighlights)
            ? u.businessHighlights
            : u.businessHighlights
            ? [u.businessHighlights]
            : [],
          businessHighlightsOther: u.businessHighlightsOther ?? "",
          // Section 7
          competition: Array.isArray(u.competition)
            ? u.competition
            : u.competition
            ? [u.competition]
            : [],
          otherCompetition: u.otherCompetition ?? "",
          competitionImpact: Array.isArray(u.competitionImpact)
            ? u.competitionImpact
            : u.competitionImpact
            ? [u.competitionImpact]
            : [],
          otherCompetitionImpact: u.otherCompetitionImpact ?? "",
          startPromotion: !u.startPromotion
            ? ""
            : u.startPromotion.toLowerCase().includes("soon")
            ? "ASAP"
            : u.startPromotion.toLowerCase().includes("next month")
            ? "NextMonth"
            : u.startPromotion.toLowerCase().includes("1-3") ||
              u.startPromotion.toLowerCase().includes("1-3")
            ? "1-3Months"
            : u.startPromotion.toLowerCase().includes("more than 3") ||
              u.startPromotion.toLowerCase().includes(">3")
            ? "MoreThan3"
            : u.startPromotion.toLowerCase().includes("explor")
            ? "ExploringOptions"
            : u.startPromotion,

          budget: u.rangeGoals,
          // Section 8
          contactMethod:
            u.preferredContact === "E-Mail"
              ? "Email"
              : u.preferredContact === "Phone"
              ? "Phone"
              : u.contactMethod ?? "",
          permission: !!(u.permission ?? u.information),
        });
        setFormValues((prev) => ({
          ...prev,
          ...mapQuestionnaireToForm(u),
        }));
        localStorage.setItem("userid", JSON.stringify(u.id));
        localStorage.setItem("BusinessQuestionnaireId", JSON.stringify(u.id));
        localStorage.setItem("loginDetails", JSON.stringify(u));
        message.success("Signed in successfully.");
        setVisible(false);
      } else {
        message.error("Business profile not found. Please sign up.");
      }
    } catch (error) {
      console.error("error signing in", error);
      message.error(error?.message || "Sign-in failed.");
    } finally {
      setLoggingIn(false);
    }
  };

  const handleVerify = async () => {
    const name = (formValues.businessName || "").trim();
    if (!name) return alert("Please enter your Agency Name to verify.");
    try {
      const res = await verifyName(AppConfig["entityNames"]["questionnaires"], {
        businessName: name,
      });
      if (res?.data?.statusCode === 0) {
        alert(res.data.message || "Business found.");
      } else {
        alert("Business name doesn't exist, please sign up.");
      }
    } catch (e) {
      console.error(e);
      alert("Could not verify business name.");
    }
  };

  return (
    <>
      { !signedIn && <Row>
        <Col
          span={24}
          style={{
            textAlign: "center",
            marginLeft: "-3%",
            marginBottom: "20px",
          }}
        >
          <h3>
            If you have already registered your business with us.
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
                showModal();
              }}
              style={{ color: "#000000", padding: "5px" }}
            >
              <b>Please Click here</b>
            </a>{" "}
            to sign in.
          </h3>
        </Col>
      </Row> }
      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Business Name">
              <Input
                placeholder="Enter your business name"
                value={formValues.businessName || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, businessName: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
              <span
                onClick={handleVerify}
                style={{
                  color: "#165874",
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                <b> Verify</b>
              </span>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Primary Contact Name">
              <Input
                placeholder="Enter contact name"
                value={formValues.contactName || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, contactName: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Contact Title">
              <Input
                placeholder="Enter contact title"
                value={formValues.contactTitle || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, contactTitle: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Email Address">
              <Input
                placeholder="Enter email address"
                value={formValues.email || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, email: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Phone Number">
              <NumberFormat
                className="input_width"
                format="+1 (###) ###-####"
                style={{
                  borderRadius: "50px",
                  // width: "400px",
                  height: "40px",
                  padding: "10px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                }}
                value={formValues.phone || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, phone: e.target.value })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Section Title for Address */}
        <h3 style={{ marginTop: "30px" }}>Business Address</h3>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Street Address">
              <Input
                placeholder="Enter street address"
                value={formValues.street || ""}
                onChange={handleStreetChange}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="City">
              <Input
                placeholder="Enter city"
                value={formValues.city || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, city: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="State">
              <Input
                placeholder="State"
                value={formValues.state || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, state: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Zip Code">
              <Input
                placeholder="Enter zip code"
                value={formValues.zip || ""}
                onChange={(e) =>
                  setFormValues({ ...formValues, zip: e.target.value })
                }
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {visible && (
        <Form onSubmit={handleSignin} id="loginForm">
        <Modal
          title="SIGN-IN"
          visible={visible}
          onCancel={hideModal}
          footer={
            <div style={{ height: 35 }}>
              <Button
                type="primary"
                htmlType="submit"
                form="loginForm"
                loading={loggingIn}
                style={{ float: "right" }}
              >
                Log in
              </Button>
            </div>
          }
        >
          <Form.Item label="Email Address :">
            <Input
              className="input_modal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Password">
            <Input.Password
              className="input_password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
           <Link to={{
              pathname: "/app/ForgotPassword",
              search: "?profileType=questionnaires",
              state: { fromHeader: true },
            }}
              onClick={() => {
                setVisible(false);
                sessionStorage.setItem("backSrc", "header");
              }}
              style={{
                  color: "rgb(22, 88, 116)",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display:'flex',
                  justifyContent:'flex-end'
                }}
              >
            Forgot Password? click here to change it
            </Link>
        </Modal>
      </Form>
      )}      
    </>
  );
};

export default Section1;
